export const checkProps = ({ fields }) => {
  fields.forEach((field) => {
    if (typeof field.value === `undefined`) {
      throw new Error(`Field "${field.name}" is undefined`);
    }
  });
};
